import styled from 'styled-components';
import GreenTickSvg from './green-tick.svg';

const GreenTickIcon = styled(GreenTickSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '7.5rem'};
  height: ${props => props.height || '4.5rem'};
`;

export default GreenTickIcon;
